import { alpha, styled } from "@mui/material";

export const NoResultsCard = styled("div")(({ theme }) => ({
  background: alpha(theme.palette.primary.main, 0.05),
  textAlign: "left",
  padding: "1rem",
  borderRadius: "6px"
}));
